import React from "react";
/* import "./messageTable.css";
 */
const Message = (props) => (
  <div className="containerMessageTable">
    <h3>{props.message}</h3>
  </div>
);

export default Message;